import jwtDecode from 'jwt-decode';
import memoizeOne from 'memoize-one';
import ReactGA from 'react-ga';

import { currentJwt } from '@src/utils/jwtHelpers';

const getUserId = (jwtObj) => {
    if (!jwtObj) {
        return '';
    }

    if (jwtObj.agent_code) {
        return jwtObj.agent_code;
    }

    if (jwtObj.producer_id) {
        return jwtObj.producer_id;
    }

    return jwtObj.uuid;
};

const getData = (jwt) => {
    const decodedJwt = jwtDecode(jwt);
    if (!decodedJwt) return {};

    return {
        accessLevel: decodedJwt.access_level,
        salesChannel: decodedJwt.sales_channel || null,
        userId: getUserId(decodedJwt),
    };
};

const memoizedData = memoizeOne(getData);

export default function googleAnalytics(history) {
    const jwt = currentJwt();

    const { accessLevel, salesChannel, userId } = memoizedData(jwt);

    if (!jwt) {
        return;
    }

    if (accessLevel === 'admin') {
        return;
    }

    if (!process.env.GA_ID) {
        return;
    }

    ReactGA.initialize(process.env.GA_ID, {
        debug: process.env.FRONTEND_ENV !== 'production',
        titleCase: false,
        gaOptions: {
            userId,
        },
    });

    // User Id as Custom Dimension
    ReactGA.set({ dimension1: userId });

    // Sales Channel as Custom Dimension
    ReactGA.set({ dimension2: salesChannel });

    history.listen((location) => {
        const pageView = location.search ? `${location.pathname}${location.search}` : location.pathname;
        ReactGA.set({
            page: location.pathname,
        });
        ReactGA.pageview(pageView);
    });
}
